const HelpView = {
    Documentation: "documentation",
    Api: "api",
    PopdockScript: "popdock-script",
    Home: "home",
    GettingStarted: "getting-started",
    WhatsNew: "whats-new",
    Connectors: "connectors",
    Markdown: "_markdown_view_"
};

const HelpItemType = {
    Article: "Article",
    Category: "Category",
    Function: "Function",
    ResourceGroup: "ResourceGroup",
    Resource: "Resource",
    Endpoint: "Endpoint"
};

const SearchType = {
    All: 0,
    ProductDocs: 1,
    PopdockScript: 2,
    Api: 3
};

const TileType = {
    Subtitle: 1,
    SortingGroup: 2
};

const RelatedItemType = {
    Article: 1,
    External: 2
};

const Constants = {
    DocPageTitle: "Popdock documentation",
    DocPageDescription: "Learn how to configure and use Popdock.",
    PopScriptPageTitle: "Popdock script",
    PopScriptPageDescription: "Learn how to configure and use Popdock.",
    //DocumentationBaseUrl: "http://localhost:5173/docs/",
    DocumentationBaseUrl: "https://help.popdock.com/docs/"
}

export { HelpView, HelpItemType, SearchType, TileType, RelatedItemType, Constants };